// REDUCER FOR error detection during customer/company creation
export function creationError(state = {}, action) {
    switch (action.type) {
        case "CUSTOMER/COMPANY_CREATEERROR":
        console.log(action.data)
            return action.data
        default:
            return state
    }
}